import type { ReactNode } from 'react';

/**
 * Montants et nombres — RG-001.
 *
 * Entiers de FCFA, toujours. Afficher « 1 500,00 F » laisserait croire qu'un
 * centime existe, et quelqu'un finirait par chercher à en rendre.
 */

/**
 * Groupe les milliers par une espace INSÉCABLE.
 *
 * Écrit à la main plutôt que délégué à `Intl` : le séparateur des locales
 * françaises varie selon le moteur — espace insécable, espace fine, parfois
 * ordinaire. Un montant qui change d'aspect selon le navigateur n'est pas
 * acceptable sur un écran comptable.
 */
function grouper(valeur: number): string {
  const negatif = valeur < 0;
  const chiffres = Math.abs(Math.trunc(valeur)).toString();

  let sortie = '';
  for (let index = 0; index < chiffres.length; index += 1) {
    if (index > 0 && (chiffres.length - index) % 3 === 0) {
      sortie += '\u00a0';
    }
    sortie += chiffres[index] ?? '';
  }

  return negatif ? `-${sortie}` : sortie;
}

export function formaterFcfa(valeur: number): string {
  return `${grouper(valeur)}\u00a0F`;
}

/**
 * Montant en FCFA.
 *
 * [total] pose la règle DOUBLE. C'est le seul moyen de l'obtenir : elle marque
 * un total réel — bénéfice, sous-total, total — et un montant intermédiaire
 * qui la porterait se lirait comme un résultat.
 */
export function Montant({
  valeur,
  total = false,
}: {
  valeur: number | null | undefined;
  total?: boolean;
}): ReactNode {
  if (valeur === null || valeur === undefined) {
    return <span className="amount">—</span>;
  }

  return (
    <span className={total ? 'amount amount-total' : 'amount'}>
      {formaterFcfa(valeur)}
    </span>
  );
}

/** Nombre sans unité — quantités, compteurs. */
export function Nombre({
  valeur,
}: {
  valeur: number | null | undefined;
}): ReactNode {
  if (valeur === null || valeur === undefined) {
    return <span className="amount">—</span>;
  }
  return <span className="amount">{grouper(valeur)}</span>;
}
